<div class="prefixCot formulario-cotiza">
  <div class="formulario-cotiza" style="max-width:805px">

    @if (cotizadorService.successCotiza()?.exito && cotizadorService.successCotiza()?.data) {
      <app-cotizacion 
        [cotizacion]="cotizadorService.successCotiza()!.data!"
        (onCotizar)="handleCotizarResultado($event)"
        (onRegresar)="handleRegresar()">
      </app-cotizacion>
    } @else {
      <form [formGroup]="form">
        
        <!-- Desktop View -->
        <div class="contenidoFormularioDesktop hidden-xs">
          <div class="col-md-12 col-sm-12 col-xs-12 contenidoDesktop">
            <br/>
            <div class="col-md-12 col-sm-12 col-xs-12">
              <div class="col-md-6 col-sm-6 col-xs-6">
                <div class="form-group">
                  <label htmlFor="nombre">Nombre <span class="requiredIn">*</span></label>
                  <input type="text" maxLength="40" class="form-control" id="nombre" formControlName="nombre"/>
                  @if (formControls['nombre'].touched && formControls['nombre'].invalid) {
                    <p class="errorMsj">Capture un nombre válido.</p>
                  }
                </div>
              </div>

              <div class="col-md-6 col-sm-6 col-xs-6">
                <div class="form-group">
                  <label htmlFor="apellidos">Apellidos <span class="requiredIn">*</span></label>
                  <input type="text" maxLength="40" class="form-control" id="apellidos" formControlName="apellidos"/>
                  @if (formControls['apellidos'].touched && formControls['apellidos'].invalid) {
                    <p class="errorMsj">Capture apellidos válidos.</p>
                  }
                </div>
              </div>
            </div>

            <div class="col-md-8 col-sm-8 col-xs-8">
              <div class="col-md-12 col-sm-12 col-xs-12">
                <div class="form-group">
                  <label htmlFor="correo">Correo Electrónico <span class="requiredIn">*</span></label>
                  <input type="text" maxLength="40" class="form-control" id="correo" formControlName="correo"/>
                  @if (formControls['correo'].touched && formControls['correo'].invalid) {
                    <p class="errorMsj">Capture un correo válido.</p>
                  }
                </div>
              </div>
            </div>

            <div class="col-md-12 col-sm-12 col-xs-12">
              <div class="col-md-6 col-sm-6 col-xs-6">
                <div class="form-group">
                  <label htmlFor="tTelefono">Tipo de Teléfono <span class="requiredIn">*</span></label>
                  <select id="tTelefono" formControlName="tTelefono" class="form-control">
                    <option value="celular">Celular</option>
                    <option value="fijo">Fijo</option>
                  </select>
                </div>
              </div>

              <div class="col-md-6 col-sm-6 col-xs-6">
                <div class="form-group">
                  <label htmlFor="telefono">Teléfono (10 dígitos) <span class="requiredIn">*</span></label>
                  <input type="text" maxLength="10" class="form-control" id="telefono" formControlName="telefono"/>
                  @if (formControls['telefono'].touched && formControls['telefono'].invalid) {
                    <p class="errorMsj">Capture un teléfono válido.</p>
                  }
                </div>
              </div>
            </div>

            <div class="col-md-12 col-sm-12 col-xs-12">
              <div class="col-md-4 col-sm-4 col-xs-4">
                <label>Género <span class="requiredIn">*</span></label><br/>
                <div class="text-center">
                  <label>Masculino <input type="radio" value="H" formControlName="genero"/></label>&nbsp;
                  <label>Femenino <input type="radio" value="M" formControlName="genero"/></label>
                </div>
              </div>

              <div class="col-md-4 col-sm-4 col-xs-4">
                <label>¿Fumas? <span class="requiredIn">*</span></label><br/>
                <div class="text-center">
                  <label>Sí <input type="radio" value="S" formControlName="fuma"/></label>&nbsp;
                  <label>No <input type="radio" value="N" formControlName="fuma"/></label>
                </div>
              </div>

              <div class="col-md-4 col-sm-4 col-xs-4">
                <div class="form-group">
                  <label htmlFor="ingreso">Ingreso Mensual <span class="requiredIn">*</span></label>
                  <input type="text" maxLength="6" class="form-control" id="ingreso" formControlName="ingreso"/>
                  @if (formControls['ingreso'].touched && formControls['ingreso'].invalid) {
                    <p class="errorMsj">{{ formControls['ingreso'].errors?.['custom'] || 'Capture un ingreso válido.' }}</p>
                  }
                </div>
              </div>
            </div>

            <div class="col-md-12 col-sm-12 col-xs-12">
              <div class="col-md-6 col-sm-6 col-xs-6 text-left">
                <label>Edad Actual <span class="requiredIn">*</span></label><br/>
                <b style="margin-left:20px;font-size:24px;color:#002D74">{{ formControls['edad_actual'].value }}</b>
              </div>
              <div class="col-md-6 col-sm-6 col-xs-6 text-right">
                <label>Edad a la que deseo retirarme <span class="requiredIn">*</span></label><br/>
                <b style="margin-right:77px;font-size:24px;color:#002D74">{{ formControls['edadretiro'].value }}</b>
              </div>
            </div>

<div class="col-md-12 col-sm-12 col-xs-12" style="margin-top: 10px; margin-bottom: 40px; padding: 0 15px;">
  
  <div class="wrapper-regla-edades">
    
    <div class="dual-range-container">
      
      <div 
        class="range-track-highlight"
        [style.left]="'calc(' + getEdadActualPercent() + '% + ' + (12 - (getEdadActualPercent() * 0.24)) + 'px)'"
        [style.width]="'calc(' + (getEdadRetiroPercent() - getEdadActualPercent()) + '% - ' + ((getEdadRetiroPercent() - getEdadActualPercent()) * 0.24) + 'px)'">
      </div>

      <input
        type="range"
        min="18"
        max="70"
        formControlName="edad_actual"
        (input)="onEdadActualRangeChange($event)"
        class="range-input"
      />

      <input
        type="range"
        min="18"
        max="70"
        formControlName="edadretiro"
        (input)="onEdadRetiroRangeChange($event)"
        class="range-input"
      />
    </div>

    <div class="reglaEdades"></div>

  </div>

</div>

            <div class="col-md-12 col-sm-12 col-xs-12">
              <div class="col-md-12 col-sm-12 col-xs-12">
                <label>% de mi sueldo que deseo recibir durante mi retiro <span class="requiredIn">*</span></label>
              </div>
            </div>

            <div class="col-md-9 col-sm-9 col-xs-9" style="margin-top: 10px; margin-bottom: 40px; padding-left: 33px;">
              <div style="margin-left: 16px;" id="rangoPorcentaje">
                <input
                  type="range"
                  min="50"
                  max="100"
                  formControlName="porSueldo"
                  (input)="onPorSueldoRangeChange($event)"
                  class="form-range"
                />
              </div>
              <div class="reglaPorcentaje"></div>
            </div>

            <div class="col-md-2 col-sm-2 col-xs-2">
              <label class="labelPorSeldo" style="font-size: 24px; padding-left: 40px;">
                {{ formControls['porSueldo'].value }}%
              </label>
            </div>

            <div class="col-md-12 col-sm-12 col-xs-12">
              <div class="col-md-5 col-sm-5 col-xs-5">
                <label htmlFor="anios_pension">Número de años que deseo recibir mi pensión <span class="requiredIn">*</span></label>
              </div>
              <div class="col-md-4 col-sm-4 col-xs-4">
                <div class="form-group">
                  <input type="text" maxLength="2" class="form-control" id="anios_pension" formControlName="anios_pension"/>
                  @if (formControls['anios_pension'].touched && formControls['anios_pension'].invalid) {
                    <p class="errorMsj">{{ formControls['anios_pension'].errors?.['custom'] || 'Campo requerido.' }}</p>
                  }
                </div>
              </div>
            </div>

            <div class="col-md-12 col-sm-12 col-xs-12">
              <div class="col-md-5 col-sm-5 col-xs-5">
                <label htmlFor="ahorro_mensual">¿Cuánto puedo ahorrar mensualmente para mi Retiro?</label>
              </div>
              <div class="col-md-5 col-sm-5 col-xs-5">
                <div class="form-group">
                  <input type="text" maxLength="6" class="form-control" id="ahorro_mensual" formControlName="ahorro_mensual"/>
                  @if (formControls['ahorro_mensual'].touched && formControls['ahorro_mensual'].invalid) {
                    <p class="errorMsj">{{ formControls['ahorro_mensual'].errors?.['custom'] }}</p>
                  }
                </div>
              </div>
            </div>
          </div>

          <div class="col-md-12 col-sm-12 col-xs-12" style="margin-top:10px;">
            <div class="col-md-12 col-sm-12 col-xs-12">
              <label>
                <input type="checkbox" class="classCheck" formControlName="contacto"/> 
                Deseo ser contactado para seguimiento a mi cotización. Conozco y entiendo que mis datos serán tratados conforme al Aviso de Privacidad de GNP.
              </label>
            </div>
          </div>

          <div class="col-md-12 col-sm-12 col-xs-12" id="divBtnCotizar">
            <div class="col-md-12 col-sm-12 col-xs-12 text-center">
              <label>Los datos marcados con <span class="requiredIn">*</span> son obligatorios.</label>
            </div>
            <div class="col-md-12 col-sm-12 col-xs-12 text-center">
              <button type="button" class="btn btn-gnp" (click)="enviar()">Cotizar</button>
            </div>
          </div>
        </div>

        <!-- Mobile View -->
        <div class="contenidoFormulario hidden-md hidden-sm hidden-lg">
          <div class="col-md-12 col-sm-12 col-xs-12">
            <div class="col-md-6 col-sm-6 col-xs-6">
              <div class="form-group">
                <label htmlFor="nombre_m">Nombre <span class="requiredIn">*</span></label>
                <input type="text" maxLength="40" class="form-control" id="nombre_m" formControlName="nombre"/>
                @if (formControls['nombre'].touched && formControls['nombre'].invalid) {
                  <p class="errorMsj">Capture un nombre válido.</p>
                }
              </div>
            </div>

            <div class="col-md-6 col-sm-6 col-xs-6">
              <div class="form-group">
                <label htmlFor="apellidos_m">Apellidos <span class="requiredIn">*</span></label>
                <input type="text" maxLength="40" class="form-control" id="apellidos_m" formControlName="apellidos"/>
                @if (formControls['apellidos'].touched && formControls['apellidos'].invalid) {
                  <p class="errorMsj">Capture apellidos válidos.</p>
                }
              </div>
            </div>
          </div>

          <div class="col-md-12 col-sm-12 col-xs-12">
            <div class="col-md-12 col-sm-12 col-xs-12">
              <div class="form-group">
                <label htmlFor="correo_m">Correo Electrónico <span class="requiredIn">*</span></label>
                <input type="text" maxLength="40" class="form-control" id="correo_m" formControlName="correo"/>
                @if (formControls['correo'].touched && formControls['correo'].invalid) {
                  <p class="errorMsj">Capture un correo válido.</p>
                }
              </div>
            </div>
          </div>

          <div class="col-md-12 col-sm-12 col-xs-12">
            <div class="col-md-6 col-sm-6 col-xs-6">
              <div class="form-group formTipoTelefono">
                <label htmlFor="tTelefono_m">Tipo de Teléfono <span class="requiredIn">*</span></label>
                <select id="tTelefono_m" formControlName="tTelefono" class="form-control">
                  <option value="celular">Celular</option>
                  <option value="fijo">Fijo</option>
                </select>
              </div>
            </div>

            <div class="col-md-6 col-sm-6 col-xs-6">
              <div class="form-group">
                <label htmlFor="telefono_m">Teléfono (10 dígitos) <span class="requiredIn">*</span></label>
                <input type="text" maxLength="10" class="form-control" id="telefono_m" formControlName="telefono"/>
                @if (formControls['telefono'].touched && formControls['telefono'].invalid) {
                  <p class="errorMsj">Capture un teléfono válido.</p>
                }
              </div>
            </div>
          </div>

          <div class="col-md-12 col-sm-12 col-xs-12">
            <div class="col-md-6 col-sm-6 col-xs-6">
              <label>Género <span class="requiredIn">*</span></label><br/>
              <div class="text-center">
                <label>Masculino <input type="radio" value="H" formControlName="genero"/></label>&nbsp;
                <label>Femenino <input type="radio" value="M" formControlName="genero"/></label>
              </div>
            </div>

            <div class="col-md-6 col-sm-6 col-xs-6">
              <label>¿Fumas? <span class="requiredIn">*</span></label><br/>
              <div class="text-center">
                <label>Sí <input type="radio" value="S" formControlName="fuma"/></label>&nbsp;
                <label>No <input type="radio" value="N" formControlName="fuma"/></label>
              </div>
            </div>
          </div>

          <div class="col-md-12 col-sm-12 col-xs-12">
            <div class="col-md-6 col-sm-6 col-xs-6">
              <div class="form-group">
                <label htmlFor="ingreso_m">Ingreso Mensual <span class="requiredIn">*</span></label>
                <input type="text" maxLength="6" class="form-control" id="ingreso_m" formControlName="ingreso"/>
                @if (formControls['ingreso'].touched && formControls['ingreso'].invalid) {
                  <p class="errorMsj">{{ formControls['ingreso'].errors?.['custom'] || 'Capture un ingreso válido.' }}</p>
                }
              </div>
            </div>

            <div class="col-md-6 col-sm-6 col-xs-6">
              <div class="form-group formEdadActual">
                <label htmlFor="edad_actual_m">Edad Actual <span class="requiredIn">*</span></label>
                <input type="text" maxLength="2" class="form-control" id="edad_actual_m" formControlName="edad_actual"/>
                @if (formControls['edad_actual'].touched && formControls['edad_actual'].invalid) {
                  <p class="errorMsj">Capture una edad válida.</p>
                }
              </div>
            </div>
          </div>

          <div class="col-md-12 col-sm-12 col-xs-12">
            <div class="col-md-6 col-sm-6 col-xs-6">
              <div class="form-group formEdadRetirarme">
                <label htmlFor="edadretiro_m">Edad Retiro <span class="requiredIn">*</span></label>
                <input type="text" maxLength="2" class="form-control" id="edadretiro_m" formControlName="edadretiro"/>
                @if (formControls['edadretiro'].touched && formControls['edadretiro'].invalid) {
                  <p class="errorMsj">Capture una edad válida.</p>
                }
              </div>
            </div>

            <div class="col-md-6 col-sm-6 col-xs-6">
              <div class="form-group formPorcentaje">
                <label htmlFor="porSueldo_m">% Sueldo <span class="requiredIn">*</span></label>
                <input type="text" maxLength="3" class="form-control" id="porSueldo_m" formControlName="porSueldo"/>
                @if (formControls['porSueldo'].touched && formControls['porSueldo'].invalid) {
                  <p class="errorMsj">Capture un porcentaje válido.</p>
                }
              </div>
            </div>
          </div>

          <div class="col-md-12 col-sm-12 col-xs-12">
            <div class="col-md-6 col-sm-6 col-xs-6">
              <div class="form-group formPeriodo">
                <label htmlFor="anios_pension_m">Años Pensión <span class="requiredIn">*</span></label>
                <input type="text" maxLength="2" class="form-control" id="anios_pension_m" formControlName="anios_pension"/>
                @if (formControls['anios_pension'].touched && formControls['anios_pension'].invalid) {
                  <p class="errorMsj">{{ formControls['anios_pension'].errors?.['custom'] || 'Campo requerido.' }}</p>
                }
              </div>
            </div>

            <div class="col-md-6 col-sm-6 col-xs-6">
              <div class="form-group">
                <label htmlFor="ahorro_mensual_m">Ahorro Mensual</label>
                <input type="text" maxLength="6" class="form-control" id="ahorro_mensual_m" formControlName="ahorro_mensual"/>
                @if (formControls['ahorro_mensual'].touched && formControls['ahorro_mensual'].invalid) {
                  <p class="errorMsj">{{ formControls['ahorro_mensual'].errors?.['custom'] }}</p>
                }
              </div>
            </div>
          </div>

          <div class="col-md-12 col-sm-12 col-xs-12">
            <div class="col-md-12 col-sm-12 col-xs-12">
              <label>
                <input type="checkbox" class="classCheck" formControlName="contacto"/> 
                Deseo ser contactado para seguimiento a mi cotización. Conozco y entiendo que mis datos serán tratados conforme al Aviso de Privacidad de GNP.
              </label>
            </div>
          </div>

          <div class="col-md-12 col-sm-12 col-xs-12" id="divBtnCotizar_m">
            <div class="col-md-6 col-sm-6 col-xs-6">
              <label>Los datos marcados con <span class="requiredIn">*</span> son obligatorios.</label>
            </div>
            <div class="col-md-6 col-sm-6 col-xs-6 text-right">
              <button type="button" class="btn btn-gnp" (click)="enviar()">Cotizar</button>
            </div>
          </div>
        </div>

      </form>
    }

    @if (cotizadorService.loading()) {
      <div class="gnp-loading">
        <div class="circle-orange"></div>
        <div class="circle-blue"></div>
        <div class="logo">
          <img src="https://storage.googleapis.com/static-portalcorporativo.gnp.com.mx/images/site/logo_header @1x.svg" class="fr-fic fr-dib" alt="Logo GNP"/>
        </div>
      </div>
    }

  </div>
</div>

<app-modal
  [mostrar]="mostrarModal()"
  [propsModal]="propsModal()"
  (onCerrar)="cerrarModal()">
</app-modal>